import { useState, useEffect, useRef } from 'react';

import Collapse from '@mui/material/Collapse';

import { DisplayError } from 'components/ErrorMessage';
import Message from 'components/messages/Message';

export default function ErrorAlert({ error = null }) {
	const scrollRef = useRef(null);
	const [alertErrors, setAlertErrors] = useState([]);

	const addError = error => {
		if (error) {
			const errorAlreadyExists = alertErrors.some(e => {
				if (error.message && e.error.message === error.message) {
					return true;
				}

				if (error && e.error === error) {
					return true;
				}

				return false;
			});

			if (errorAlreadyExists) return;

			setAlertErrors(prev => [
				...prev,
				{
					error: error,
					open: true,
				},
			]);

			if (scrollRef.current) {
				const rect = scrollRef.current.getBoundingClientRect();
				if (rect.top < window.innerHeight && rect.bottom >= 0) {
					return;
				}

				scrollRef.current.scrollIntoView({ behavior: 'smooth' });
			}
		}
	};

	const handleClose = index => {
		const currentErrors = [...alertErrors];
		currentErrors[index].open = false;
		setAlertErrors(currentErrors);
	};

	useEffect(() => {
		if (!error) return;

		if (Array.isArray(error)) {
			error.forEach(e => {
				addError(e);
			});
		} else {
			addError(error);
		}
	}, [error]);

	if (alertErrors.length === 0) return null;

	return (
		<div ref={scrollRef}>
			{alertErrors.map((e, index) => {
				return (
					<Collapse in={e.open} key={`error-alert-${index}`}>
						<Message
							type="error"
							title="Feilmelding:"
							onClose={() => {
								handleClose(index);
							}}
						>
							<DisplayError error={e.error} />
						</Message>
					</Collapse>
				);
			})}
		</div>
	);
}
